module.exports = __webpack_public_path__ + "img/donation-prep-3.363a2e90.png";